var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`stockChange ${_vm.getCardClass}`},[_vm._v(_vm._s(_vm.dayChangeValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }